/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaches_Page_Week_TitleInputs */

const en_coaches_page_week_title = /** @type {(inputs: Coaches_Page_Week_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No messages. No waiting for a reply.`)
};

const pl_coaches_page_week_title = /** @type {(inputs: Coaches_Page_Week_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez pisania. Bez czekania na odpowiedź.`)
};

/**
* | output |
* | --- |
* | "No messages. No waiting for a reply." |
*
* @param {Coaches_Page_Week_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const coaches_page_week_title = /** @type {((inputs?: Coaches_Page_Week_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaches_Page_Week_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_coaches_page_week_title(inputs)
	return en_coaches_page_week_title(inputs)
});